export default __webpack_public_path__ + "static/media/restrospective-1.a9769ec4.svg";